import script from "./InformativeAlPubblicoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InformativeAlPubblicoPage.vue?vue&type=script&setup=true&lang=js"

import "./InformativeAlPubblicoPage.vue?vue&type=style&index=0&id=2877154a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2877154a"]])

export default __exports__